import { FC } from 'react';

import { Tag } from 'enable-ui';

export const TagComponent: FC<{
  text: string;
  color: string;
  isDot?: boolean;
  customStyle?: React.CSSProperties;
  dotStyle?: React.CSSProperties;
}> = ({ text, color, isDot = true, customStyle, dotStyle }) => {
  const baseStyle = {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '22px',
    borderRadius: '12px',
    padding: 0,
    color: color,
    border: '1px solid transparent',
    background: 'transparent',
    ...customStyle,
  };

  const baseDotStyle = {
    backgroundColor: color,
    ...dotStyle,
  };

  return (
    <Tag style={baseStyle} dot={isDot} dotStyle={baseDotStyle}>
      {text}
    </Tag>
  );
};
